import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { UserConsentsApi } from '../../../apis/UserConsentsApi/UserConsentsApi.ts';
import { IUserPreferences } from '../UserConsent.ts';

export function useAcceptMMEWarning() {
    const queryClient = useQueryClient();

    return useMutation<void, AppMedError, void>({
        mutationKey: [QueryKeys.userPreferences, 'acceptMMEWarning'],
        mutationFn: async () => {
            await UserConsentsApi.patchMMEWarning({ accepted: true });
        },
        onSuccess: () => {
            // Optimistically update the cache
            queryClient.setQueryData<IUserPreferences>(
                [QueryKeys.userPreferences],
                (prev) => {
                    if (!prev) return prev;
                    return {
                        ...prev,
                        mmeCalculatorWarningAccepted: true,
                    };
                },
            );

            // Invalidate to ensure fresh data
            queryClient.invalidateQueries({ queryKey: [QueryKeys.userPreferences] });
        },
        onError: (error) => {
            console.error('Error accepting MME warning:', error);
        },
    });
}
